import { CustomerAPI } from 'api'

import { map, is } from 'ramda'

export const createStaticSegment = (segment) => (
  CustomerAPI.post(`/user_lists`, segment)
)

export const addToMemberList = (users, segmentId) => (
  CustomerAPI.patch(`/user_lists/${segmentId}/members`, users)
)

export const getStaticSegments = (orgId) => (
  CustomerAPI.get(`/user_lists`, {params: {type: 'ID_LIST'}})
)

export const getFilteredContacts = (query, size = 25, startFrom = 0) => (
  CustomerAPI.post(`/segment/filter`, query, {params: {size, from: startFrom}})
)

export const searchContacts = ({ query = {}, size = 25, sortAscended, sortField, startFrom = 0 }) => {
  const params = {
    from: startFrom,
    size,
    sortAscended,
    sortField,
  }

  let body = {}

  if (is(String, query)) {
    params.q = query
  } else if (is(Object, query)) {
    body = query
  }

  return CustomerAPI.post(`/segment/search`, body, { params })
}

export const newCreateSegment = (query) => (
  CustomerAPI.post(`/segment/create`, query)
)

export const getFilteredSegmentList = (query, orgId, size = 25, startFrom = 0) => (
  CustomerAPI.get(`/user_lists/paginated/name`, {params: {orgId, withTotal: true, filter: query, size, from: startFrom}} )
)

export const getFilteredListByType = (orgId, size = 25, startFrom = 0, filter) => (
  CustomerAPI.get(`/user_lists/paginated/type`, {params: {orgId, withTotal: true, filter, size, from: startFrom}})
)

export const getNewSegmentList = ({id, startFrom, size}) => (
  CustomerAPI.get(`/segment/members/hydrate/${id}`, {params: {size, from: startFrom}})
)

export const findMembershipInNewSegment =  (id, startFrom, size, query) => (
  CustomerAPI.get(`/segment/members/hydrate/${id}`, {params: {size, from: startFrom, nameOrEmail: query}})
)

export const archiveSegments = async (segments) => {
  const archiveGroup = map((id) => CustomerAPI.patch(`/user_lists/${id}`, {status: 'ARCHIVED'}), segments)
  return Promise.all(archiveGroup)
}

export const archiveSingleSegment = (segmentId) => {
  return archiveSegments([segmentId])
}

export const exportSegmentCSV = (id) => (
  CustomerAPI.get(`/user_lists/${id}/members/csv/email`)
)

export const getSegmentQuery = (id) => (
  CustomerAPI.get(`/segment/query/${id}`)
)

export const deleteAllMembersInSegment = (orgId, segmentId) => (
  CustomerAPI.delete(`/organizations/${orgId}/end_users/user_list/${segmentId}`)
)